import { createContext, useContext } from 'react';

export interface SidebarState {
  expandedMenus: Set<string>;
  toggleMenu: (menuName: string) => void;
  isMenuExpanded: (menuName: string) => boolean;
}

export const SidebarContext = createContext<SidebarState | null>(null);

export function useSidebar(): SidebarState {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
}
